
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[year]/state-houses-of-assembly/[state]",
      function () {
        return require("private-next-pages/elections/[year]/state-houses-of-assembly/[state].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[year]/state-houses-of-assembly/[state]"])
      });
    }
  